import { getHeaders, makeRequest } from "$utils/utils";
import config from "$services/config";

const { shipping_api_url: shipping_url } = config;

export const getCarrierService = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/carrierServices/${id}`,
      "GET",
      undefined,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};

export const updateCarrierService = async (
  token: string,
  id: string,
  body: any
) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/carrierServices/${id}`,
      "PUT",
      body,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};
